export default __webpack_public_path__ + "static/media/category-12.d4a7edc2.svg";